<template>
  <div class="activity-tabs fixed-tabs" :class="{'dashboard':activeIndex==0}">

    <v-toolbar fixed tabs dense flat>

      <v-tabs v-model="activeIndex" slider-color="primary" @input="fn_tabChange">
        <v-tab v-for="(tab, index) in tabs" :key="index" ripple>{{tab.title}}</v-tab>
      </v-tabs>

    </v-toolbar>

    <v-tabs-items v-model="activeIndex" @input="fn_tabChange">

      <v-tab-item>  
        <!-- <keep-alive>
          <component :is="currentTabComponent" ref="ref_dashboard"></component>
        </keep-alive> -->
        <component :is="currentTabComponent" ref="ref_dashboard"></component>
      </v-tab-item>

      <v-tab-item>  
        <!-- <keep-alive> -->
          <component :is="currentTabComponent" ref="ref_reportList"></component>
        <!-- </keep-alive> -->
      </v-tab-item>

    </v-tabs-items>
  </div>
</template>

<script>

import dashboard from './contents/dashboard'
import reportList from './contents/reportlist'

let reportTabConfigs = require('../../../config.js').configs.reportTabConfigs;
const navigationMenu = require('../../../config.js').configs.bottomNavigation;

let tagId = 'dashboard'

  export default {
    data () {
      return {
        tabs:[
              {"id":1, "title":"Dashboard"},
              {"id":2, "title":"Report List"},
        ],
        currentTabComponent:null,
        activeIndex: null,
        search:''
      }
    },
    watch: {
      '$root.selectedLanguage': function(){
        this.fn_setBottomNavigation();
      }
    },
    methods: {

      fn_tabChange: function (tabIndex) {
        let self = this;
        reportTabConfigs.activeIndex = tabIndex;
        if(tabIndex==0){
          this.currentTabComponent = dashboard;
          setTimeout(function(){
            // self.$refs['ref_dashboard'].fn_dateRange(self.$root.dashboard.defaultDateRange);
            self.$root.fn_getLocalData('selected_date_filter', response=>{
              let data = JSON.parse(response);
              if(data && data.type){
                // self.$root.dashboard.startDate = data.startDate;
                // self.$root.dashboard.endDate = data.endDate;
                // self.$root.dashboard.periodValue = data.label;
                
                // if(!self.$root.dashboard.periodValue){
                //   self.$root.dashboard.periodValue = self.$moment(data.startDate).format('MMM') + ' - ' + self.$moment(data.endDate).format('MMM');
                // }

                let period = self.$refs['ref_dashboard'].periods.filter(item =>{
                  return item.value == data.type;
                })

                if(period && period.length){
                  self.$refs['ref_dashboard'].fn_changePeriod(period[0], data.month, data.year);
                }
                else{
                  self.$refs['ref_dashboard'].fn_changePeriod(data.type, data.month, data.year);
                }

                // self.$refs['ref_dashboard'].fn_changePeriod(period[0], data.month, data.year);
                // self.$refs['ref_dashboard'].fn_changePeriod('local_remember');
              }
              else{
                self.$refs['ref_dashboard'].fn_changePeriod({"title":"All Time", "value":"alltime"}); 
              }
            })
            // if(localStorage.getItem('selected_date_filter')){
            //   let localObj = JSON.parse(localStorage.getItem('selected_date_filter'));
            //   self.$root.dashboard.startDate = localObj.startDate;
        		// 	self.$root.dashboard.endDate = localObj.endDate;
            //   self.$root.dashboard.periodValue = localObj.label;
            //   self.$refs['ref_dashboard'].fn_changePeriod('local_remember');
            // }
            // else{
            //   self.$refs['ref_dashboard'].fn_changePeriod({"title":"All Time", "value":"alltime"});  
            // }
            // self.$refs['ref_dashboard'].fn_changePeriod({"title":"All Time", "value":"alltime"});
          },300);
        }
        else if(tabIndex==1){
          this.currentTabComponent = reportList;
          let self = this;
          setTimeout(function(){
            let scrollOptions = {"duration":0, "offset":0, "easing":"linear"};
            self.$vuetify.goTo(0, scrollOptions);
          },100);
        }
      },

      fn_setBottomNavigation : function () {

          console.log('set navigation');

          let self = this;

          let viewObject = {}

          viewObject.NavigationMenu = navigationMenu.map(item => Object.assign({}, item, { Text: this.$t('actions.bottomNav.' + item.Text.toLowerCase()) }));

          this.setBottomNavigation(tagId, viewObject, 
              {
                onSuccess: function (response) {
                  console.log(response);
                  localStorage.setItem('bottomNavigationSet', 1);
                  self.fn_showBottomNavigation();
                },
                onError: function (error) {
                  console.log(error);
                }
              }
          )
      },

      fn_showBottomNavigation: function () {

        let self = this;

        let navigationObject = {activeIndex: 1001};

        this.showBottomNavigation(tagId, navigationObject, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
            // onChange: null, 
            onMenuItemClick: function (tagId, menuId, menuAction) {
              self.$root.fn_bottomNavigationItemClick(tagId, menuId, menuAction)
            }
          }
        );
      },

      fn_hideBottomNavigation: function () {

        this.hideBottomNavigation({
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }
          }
        );
        
      },

      fn_showWebView: function () {
        this.showWebView(tagId, {}, 
          {
            onSuccess: function(response){
              console.log(response);
            }, 
            onError: function(error){
              console.log(error);
            }, 
          }
        );
      },

      fn_goBack: function(){
        if(this.$refs['ref_dashboard'].dialog_datepicker){
          this.$refs['ref_dashboard'].dialog_datepicker = false;
        }
        else if(this.$refs['ref_dashboard'].$refs['ref_dialogCustomPeriod'] && this.$refs['ref_dashboard'].$refs['ref_dialogCustomPeriod'].dialog_period_selection){
          this.$refs['ref_dashboard'].fn_closePeriodDialog();
        }
        else if(this.$refs['ref_dashboard'].$refs['ref_dialogMonthFilter'] && this.$refs['ref_dashboard'].$refs['ref_dialogMonthFilter'].dialog_filter_month){
          this.$refs['ref_dashboard'].$refs['ref_dialogMonthFilter'].closeDialogWeb();
        }
        else if(this.$refs['ref_dashboard'].$refs['ref_dialogQuarterFilter'] && this.$refs['ref_dashboard'].$refs['ref_dialogQuarterFilter'].dialog_filter_quarter){
          this.$refs['ref_dashboard'].$refs['ref_dialogQuarterFilter'].closeDialogWeb();
        }
        else{
          this.exitApp();
        }
      }

    },
    mounted: function () {
      if(reportTabConfigs.activeIndex != null){
        this.activeIndex = reportTabConfigs.activeIndex;
        this.fn_tabChange(this.activeIndex, true);
      }

      window.js_globals.fn_onBackPress = this.fn_goBack;
    },
    beforeRouteLeave (to, from , next) {
      if(to.name!="reports" && to.name!="activitytabs" && to.name!="actions" && to.name!="notifications" && to.name!="settings"){
          this.fn_hideBottomNavigation();
        }
        next();
    },
    beforeRouteEnter(to, from, next){
     next(vm => {
          if(from.name!="reports" && from.name!="activitytabs" && from.name!="actions" && from.name!="notifications" && from.name!="settings"){
              vm.fn_showWebView();
          }

          // vm.fn_showBottomNavigation();
          let bottomNavigationSet = Number(localStorage.getItem('bottomNavigationSet'))
          console.log(bottomNavigationSet);

          if(bottomNavigationSet){
            vm.fn_showBottomNavigation();
          }
          else{
            vm.fn_setBottomNavigation();
          }
      })
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/newreports/dashboard/tabs.vue